<template>
	<div class="card-container">
		<v-avatar color="#eee" size="75">
			<v-icon>
				mdi-coffee
			</v-icon>
		</v-avatar>
		<div class="card-content mt-3">
			<v-btn block color="primary" text>
				{{ category.name }}
			</v-btn>
		</div>
		<div class="card-content"></div>
	</div>
</template>

<script>
export default {
	name: "SimpleCardIcon",

	props: ["category"],

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped>
.card-container {
	padding: 10px;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: auto;
	border: 1px solid rgba(0, 0, 0, 0.1);
	text-align: center;
}
</style>
